exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-navigation-container {\n  height: 42px;\n  line-height: 42px;\n  margin: 5px 0px 5px 0px;\n  text-align: center;\n}\n.item-count-container {\n  margin-left: 20px;\n  margin-right: 20px;\n  display: inline-block;\n}\n.pagination-container {\n  margin-right: 20px;\n  display: inline-block;\n}\n.page-size-selector-container {\n  display: inline-block;\n  margin-right: 60px;\n}\n.page-size-dropdown {\n  margin-left: 10px;\n}\n", ""]);

// exports
